export enum Transportation {
	BOARDING_POINT = 'BOARDING_POINT',
	CARPOOL = 'CARPOOL',
	HOME_PICKUP = 'HOME_PICKUP',
	OWN_TRANSPORT = 'OWN_TRANSPORT',
}

export const TRANSPORTATIONS = [Transportation.BOARDING_POINT, Transportation.CARPOOL, Transportation.HOME_PICKUP, Transportation.OWN_TRANSPORT];
